import getSampleKey from 'notebook/sample-propagation/util/getSampleKey';
import {SampleDetailsWithOptionalStageRunSample} from 'workflows/util/StageRunUtil';

export default function dedupeSampleDetails(
  sampleDetails: Array<SampleDetailsWithOptionalStageRunSample>
): Array<SampleDetailsWithOptionalStageRunSample> {
  const seen = new Set();
  const newList = [];
  for (const sample of sampleDetails) {
    if (!seen.has(getSampleKey(sample))) {
      newList.push(sample);
      seen.add(getSampleKey(sample));
    }
  }
  return newList;
}

/**
 * Returns true if there are duplicate values in the given list of sample details.
 * Uses {@link getSampleKey} as a key to determine uniqueness.
 */
export function checkIfSamplesDetailsHaveDuplicates(
  sampleDetails: Array<SampleDetailsWithOptionalStageRunSample>
): boolean {
  const uniqueSampleKeys = new Set(sampleDetails.map((sample) => getSampleKey(sample)));
  return uniqueSampleKeys.size !== sampleDetails.length;
}
